export default "__VITE_ASSET__DnbhG9Id__"